import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const useStyles = makeStyles(theme => ({
  label: {
    fontSize: "1em"
  }
}));

function ChooseShades({ focus, label, selectedShades, setSelectedShades }) {
  const classes = useStyles();

  return (
    <FormControl
      focused={focus}
      component="fieldset"
      // className={classes.formControl}
    >
      <FormControlLabel
        classes={{ label: classes.label }}
        control={
          <Checkbox
            checked={!!selectedShades}
            onChange={event => {
              setSelectedShades(event.target.checked);
            }}
            name="shades"
            color="primary"
            size="small"
          />
        }
        label={label}
      />
    </FormControl>
  );
}

export default ChooseShades;
